module.exports = __webpack_public_path__ + "static/img/step6.fd1367f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide/step6.png
// module id = qvFi
// module chunks = 1